import { render } from "./CryptocurrencyWatchList.vue?vue&type=template&id=222be9cd&ts=true"
import script from "./CryptocurrencyWatchList.vue?vue&type=script&lang=ts"
export * from "./CryptocurrencyWatchList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__